import { render, staticRenderFns } from "./projecModelt.vue?vue&type=template&id=277a2ab1&scoped=true&"
import script from "./projecModelt.vue?vue&type=script&lang=js&"
export * from "./projecModelt.vue?vue&type=script&lang=js&"
import style0 from "./projecModelt.vue?vue&type=style&index=0&id=277a2ab1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277a2ab1",
  null
  
)

export default component.exports